<!-- eslint-disable -->
<template>
  <div class="p8_main_container">
    <div v-for="(versionLabel, index) in DV_versionLabels.slice().reverse()">
      <div class="p8_version_label">
        <h2>{{versionLabel}}</h2>
      </div>
      <div v-for="(changesList, index1) in DV_changeLogs.slice().reverse()[index]" class="p8_change_log_type_label">
        <h3>{{DV_changeLogTypeLabels[index][index1]}}</h3>
        <div class="p8_changes_list">
          <ul class="page-ul">
            <li v-for="item in changesList" class="p8_changes_list_item">{{item}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  export default {
    data() {
      return {
        DV_versionLabels: [
          'July 9th, 2019: V2.04.001 Release',
          'July 11th, 2019: V2.04.002 Release',
          'July 25th, 2019: V2.04.003 Release',
          'August 7th, 2019: V2.04.004 Release' ,
          'August 14th, 2019: V2.04.005 Release',
          'August 23rd, 2019: V2.04.006 Release',
          'September 10th, 2019: V2.04.007 Release',
          'October 22nd, 2019: V2.04.008 Release',
          'October 24th, 2019: V2.04.009 Release',
          'November 5th, 2019: V2.05.000 Release',
          'November 15th, 2019: V2.06.000 Release',
          'November 26th, 2019: V2.06.001 Release',
          'November 29th, 2019: V2.06.002 Release',
          'December 21st, 2019: V2.06.003 Release',
          'January 14th, 2020: V2.06.004 Release',
          'March 16th, 2020: V2.07.005 Release',
          'March 12th, 2021: V2.08.000 Release'
        ],
        DV_changeLogTypeLabels: [
          // version V1.00.000
          ['Bug Fixes', 'New Features'],
          // version V2.00.000
          ['Bug Fixes', 'New Features'],
          // version V3.00.000
          ['Bug Fixes', 'New Features'],
          // version V4.00.000
          ['Bug Fixes', 'New Features'],
          //2019-08-06
          ['Bug Fixes', 'New Features'],
          //2019-08-14
          ['Bug Fixes', 'New Features'],
           //2019-08-23
          ['Bug Fixes', 'New Features'],
          // 2019-09-10
          ['Bug Fixes', 'New Features'],
          //2019-10-22
          ['Bug Fixes', 'New Features'],
           //2019-10-24
          ['Bug Fixes', 'New Features'],
          // 2019-11-05
          ['Bug Fixes', 'New Features'],
          // 2019-11-15
          ['Bug Fixes', 'New Features'],
          // 2019-11-25
          ['Bug Fixes', 'New Features'],
          //2019-11-29
          ['Bug Fixes', 'New Features'],
          ///2019-12-21
          ['Bug Fixes', 'New Features'],
          //2020-01-14
          ['Bug Fixes', 'New Features'],
          //2021-03-12
          ['Bug Fixes', 'New Features']
        ],
        DV_changeLogs: [

          // version 1.00.00
          [
            [
              'Fixed offline indicator (red X) not showing sometimes',
              'Fixed an error when selecting an operator while creating a new rule',
              'Fixed an issue with two notification rules applied to the same attribute'
            ],
            [
              'Added number of organizations and estimated time until loaded for "my organizations"'
            ]
          ],
          // version 2.00.00
          [
            [
              'Fixed an issue with search results displaying organizations not their systems'
            ],
            [
              'Removed circular loading indicator when loading "my organizations"',
              'Added green box to the left of attributes that have control options'
            ]
          ],
          // version 3.00.00
          [
            [
              'Fixed reporting for "connected to watchdog" attribute'
            ],
            [
              'Implemented buttons to increase/decrease font size in the dashboard for tablets and deskop',
            ]
          ],
          // version 4.00.00
          [
            [
              'Adjusted timeframe bar below the reporting chart to resize properly',
              'Fixed an issue where the doghouse issue percentage was not visible on a dedicated page'
            ],
            [
              'Added searchbar for filtering attribute states to include/exclude from reporting/chart',
              'Last font size used is now saved in browsers local cache'
            ]
          ],
          //2019-08-06
          [
            [
              'Fixed an issue that caused sub-modals not reload within certain modals',
              'Fixed an issue with the login flow and loading indicator',
              'Fixed users getting redirecting to wrong/invalid URL instead of dashboard after logging in through email login.'
            ],
            [
              'Broswer compatability changes'

            ]
          ],
          //2019-08-14
          [
            [
              'Added the ability to share / bookmark a report by copying its URL'
            ],
            [
              'Increased site stability when downloading CSV data'
            ]
          ],
          //2019-08-23
          [
            [
              'Fixed an issue that caused some systems not to show up on the dashboard'
            ],
            [
              'Changed clear Doghouse icon to be a checkmark'
            ]
          ],
          // 2019-09-10
          [
            [
              'Fixed issue that could cause the dashboard to not accept new commands after being open for several days'
            ],
            [
              'Updated UI of organization tree and system devices',
              'Added collaspe icons that hide the menu buttons for a selected item to the right of selected organizations, systems, devices and attributes.',
              'Add a the ability to download the informaiton in a system or all systems in an organization as a CSV'
            ]
          ],
          //2019-10-22
          [
            [
              'Fixed an issue that could cause the organization tree not to load for users with access to certain organizations',
            ],
            [
              'Performance improvements within organization tree view'
            ]
          ],
           // 2019-10-24
          [
            [
              'Fixed an issue on the diagnostics modals that could cause data rendering to stop working when no filtering operator is selected',
              'Fixed an issue that sometimes caused the website Favicon not to show up in the browser tab',
              'Added "Connected To Watchdog" status information to csv downloads of system data and organization data',
              'Made the Doghouse history show a message stating no entries exist, when there are no entries to show'
            ],
            [
              'Added "Email Organization Keys" button on the edit menu of organizations, only owners of an organization can access this feature',
              'When an issue in the Doghouse is manually cleared it is now added to the Doghouse history log as being manually cleared',
              'Added a warning message about downloading large CSV files, we have been able to download a 300mb CSV with 1.5 million records on our development systems, however not all hardware can support that'
            ]
          ],
          // 2019-11-05
          [
            [
              'Fixed issue that caused reporting CSV files to sometimes download with an invalid format',
              'Fixed clickable mouse cursor showing up non-clickable lines in the organization tree view',
              'Fixed issue were after logging in users would sometimes have to refresh to get to the dashboard',
              'The issue some users were having with the "Collapse All" button not working on the organization tree should be fixed'
            ],
            [
              'Added Ability to send raw control commmands to devices that support them, and logs RX / TX data on devices that are configured to provide that information',
              'Changed label on doghouse history entries that are manually cleared from "Cleared" to "Manually Cleared"'
            ]
          ],
          // 2019-11-15
          [
            [
              "Fixed the device search bar on the system view not hiding devices that didn't match the search string"
            ],
            [
              'General dashboard loading speed improvments',
              'Added the organization current value report feature that allows users to download the current values of devices for an organization based off filters'
            ]
          ],
          //2019-11-26
          [
            [
              'New ogranizations will now appear in your list after creation without represhing the page',
              'Mobile viewing fixes truncate attribute values or names that are too long for the current screen'
            ],
            [
              'Changes made to allow a device to correct the order of attributes, resolves issue where a power schedule was out of order'
            ]  
          ],
           //2019-11-29
          [
            [
              'CSV download timeout issue resolved'
            ],
            [
              'Organization reporting now has filters for attribute name or attribute data, that can be used for active attributes or attribute history'
            ]
          ],
          //2019-12-21
          [
            [
              'Fixed an error where an invalid date range error would not clear after correcting the date range',
              'Changed the order of operations for CSV download, data/attribute filters are processed before collecting system and object names',
              'Fixed an issue with system reporting that added a new object to the system',
              'Fixed issue with resolved notifications in the doghouse not being cleared'
            ],
            [
              'System level attribute reporting of device history and active attributes with the same filters used in organization level reporting',
              'New backend functions to improve system load speed',
              'Added CSV reporting download progress data by showing the number of systems and objects being downloaded',
              'New backend functions used to speed up viewing system attributes also used to speed up downloading CSV data'
            ]  
          ],
          //2.07
          [
            [
              'Fixed Rendering issue with RX / TX monitoring on mobile website',
            ],
            [
              'Addition of doghouse counts for both active items and acknowledged notifications in the organization tree.',
              'Mass application of rules by selecting an organization, the edit menu, then the mass rule application option to allow searching by attribute names within all systems under the currently selected organization.',
              'Addition of an area in the doghouse for moving items off the active list onto a seperate autoclearing list called "acknowledged"',
              'Changes to organization tree UI, top of the page shows total count of systems and organizations, hovering over an organization show sub-orgs and systems contained within',
              'Enable application of custom tags for alerts in the active/acknowledged list that will maintain after clearing.',
            ]
          ],
          //2.08
          [
            [
              'Added timestamps to downloaded files when user exports data',
              'Now displays correct progress indicator on all pages',
              'Resolved issue where selecting "treat all data as numbers" no longer causes javascript issue',
              'Improved reporting on CSV downloads for offline systems, no longer downloads empty offline CSV reports',
              'No longer displays "hover" cursor over text entries field',
              'Resolved issue when reloading pages that would cause error messages',
              'Login buttons no longer overflow screen on certain devices',
              'Improved error notifications, display longer on screen',       
            ],
            [
              'Improved attribute history initilization',
              'Improved sorting performance',
              'Implimented new summary view for active, acknowledged and history items',
              'Cleared doghouse entries can now be restored to un-cleared state',
              'Datapoint view can be manually selected on reporting pages',
              'Added ability to search for a user when adding users to groups',
              'Filtered logs can now be copied to the clipboard',
            ]
          ]
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/public/p8Changelog.vue